<!-- 修改学员 添加 -->
<template>
  <div class="form_box">
    <div class="form_box__header">
      <AppPageHeader></AppPageHeader>
    </div>
    <el-card class="box-card">
      <!-- <div slot="header">
        <span>1. 填写学习班类型</span>
      </div>-->
      <div class="form_box__container">
        <div class="form_box__item_group">
          <div class="form_box__group__item">
            <div class="form_box__group__item__title">姓名：</div>
            <div class="form_box__group__item__content">
              <el-input v-model="formdata.name" placeholder="请输入姓名"></el-input>
            </div>
            <div class="form_box__group__item__tool"></div>
          </div>

          <div class="form_box__group__item">
            <div class="form_box__group__item__title">手机号：</div>
            <div class="form_box__group__item__content">
              <el-input v-model="formdata.phone" placeholder="请输入手机号" v-show="isAdmin"></el-input>
              <p v-show="!isAdmin">{{ formdata.phone }}</p>
            </div>
            <div class="form_box__group__item__tool"></div>
          </div>
        </div>

        <div class="form_box__item_group" v-show="isAdmin">
          <div class="form_box__group__item">
            <div class="form_box__group__item__title">身份证：</div>
            <div class="form_box__group__item__content">
              <el-input v-model="formdata.idcard" placeholder="请输入身份证"></el-input>
            </div>
            <div class="form_box__group__item__tool"></div>
          </div>

          <div class="form_box__group__item">
            <div class="form_box__group__item__title">
               是否是党员：
            </div>
            <div class="form_box__group__item__content">
              <el-radio-group v-model="formdata.isccp">
                <el-radio :label="0">不是</el-radio>
                <el-radio :label="1">是</el-radio>
              </el-radio-group>
            </div>
            <div class="form_box__group__item__tool"></div>
          </div>
        </div>

        <div class="form_box__item_group" v-show="isAdmin">
          <div class="form_box__group__item">
            <div class="form_box__group__item__title">所属单位：</div>
            <div class="form_box__group__item__content">
              <ClassUnitSelect
                :showtitle="false"
                ref="ClassUnitSelect"
                :size="'large'"
                @onValueChanged="OnUnitSelectValueChanged"
              ></ClassUnitSelect>
            </div>
            <div class="form_box__group__item__tool"></div>
          </div>
        </div>

        <div class="form_box__item_group"  v-show="isAdmin">
          <div class="form_box__group__item">
            <div class="form_box__group__item__title">所属党组织：</div>
            <div class="form_box__group__item__content">
              <PartyOrgSelect
                :showtitle="false"
                ref="PartyOrgSelect"
                :size="'large'"
                @onValueChanged="OnPartySelectValueChanged"
              ></PartyOrgSelect>
            </div>
            <div class="form_box__group__item__tool"></div>
          </div>
        </div>

        <div class="form_box__item_group" v-show="isAdmin">
          <div class="form_box__group__item">
            <div class="form_box__group__item__title">党内职务：</div>
            <div class="form_box__group__item__content">
              <el-input v-model="formdata.partyjob" placeholder="请输入党内职务"></el-input>
            </div>
            <div class="form_box__group__item__tool"></div>
          </div>

          <div class="form_box__group__item">
            <div class="form_box__group__item__title">行政职务：</div>
            <div class="form_box__group__item__content">
              <el-input v-model="formdata.adminjob" placeholder="请输入行政职务"></el-input>
            </div>
            <div class="form_box__group__item__tool"></div>
          </div>
        </div>

        <div class="form_box__item_group">
          <div class="form_box__group__item">
            <div class="form_box__group__item__title flex flex-col">
              <p>是否已退休（不在统计内表示）</p>
              <p class="_tips">* 党员信息的修改需要到复兴壹号后台，通过转出操作将人员转到离退休支部</p>
            </div>
            <div class="form_box__group__item__content">
              <el-radio-group v-model="formdata.retire">
                <el-radio :label="0">否</el-radio>
                <el-radio :label="1">是</el-radio>
              </el-radio-group>
            </div>
          </div>
        </div>

        <div class="form_box__item_group">
          <div class="form_box__group__item">
            <div class="form_box__group__item__title">是否标记已完善信息</div>
            <div class="form_box__group__item__content">
              <el-radio-group v-model="formdata.iscomplete">
                <el-radio :label="0">否</el-radio>
                <el-radio :label="1">是</el-radio>
              </el-radio-group>
            </div>
            <div class="form_box__group__item__tool"></div>
          </div>
        </div>




        
        <div class="form_box__item_group">
          <div class="form_box__group__item">
            <div class="form_box__group__item__title">职称选择：</div>
            <div class="form_box__group__item__content">
              <ZhichenSelect @onDataChanged="onZhichenChanged" ref="ZhichenSelect"></ZhichenSelect>
            </div>
            <div class="form_box__group__item__tool"></div>
          </div>

          <div class="form_box__group__item" v-if="showZaibianEdit">
            <div class="form_box__group__item__title">是否是在编党员：</div>
            <div class="form_box__group__item__content">
              <el-radio-group v-model="formdata.zaibian">
                <el-radio :label="0">否</el-radio>
                <el-radio :label="1">是</el-radio>
              </el-radio-group>
            </div>
            <div class="form_box__group__item__tool"></div>
          </div>

        </div>

        <div class="form_box__item_group">
          <div class="form_box__group__item">
            <div class="form_box__group__item__title">性别</div>
            <div class="form_box__group__item__content">
              <el-select v-model="formdata2.gender" placeholder="请选择性别" clearable>
                <el-option :key="0" label="男性" value="男性"></el-option>
                <el-option :key="0" label="女性" value="女性"></el-option>
              </el-select>
            </div>
            <div class="form_box__group__item__tool"></div>
          </div>

        </div>



      </div>



    </el-card>
    <el-card class="box-card" style="margin-top: 20px;" v-loading="loading">
      <el-button style="margin-top: 12px;" type="primary" @click="save">更新</el-button>
      <el-button style="margin-top: 12px;" type="primary" @click="saveGender">修改性别</el-button>
    </el-card>
  </div>
</template>


<script>
// @ is an alias to /src
import { editInitApi, editSaveApi,editSaveGenderApi,editInitGenderApi } from "@/api/module/user/user";

import { PartyOrgSelect } from "@/views/module/partyOrganization/components";
import { ClassUnitSelect } from "@/views/module/classunit/components";
import { ZhichenSelect} from "./comp"

export default {
  name: 'useredit',
  components: {
    PartyOrgSelect,ClassUnitSelect,ZhichenSelect
  },
  data(){
    return {
      formdata : {
      // id : "",
      // name : "",
      // phone : "",
      // idcard : "",
      // unitid : "",
      // partyid : "",
      // partyjob : "",
      // adminjob : "",
      // retire : '',
      // iscpp : 0,
      },

      formdata2 : {
      },


      loading : false,
      // status : ""
    }
  },
  methods:{
    save() {
      this.loading = true;

      editSaveApi(this.formdata)
        .then(response => {
          this.$message({
            message: "操作成功",
            type: "success"
          });
          this.init();

        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
          // this.init();
        });
    },

    saveGender() {
      this.loading = true;

      editSaveGenderApi(this.formdata2)
        .then(response => {
          this.$message({
            message: "操作成功",
            type: "success"
          });
          this.init();

        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
          // this.init();
        });
    },

    init() {
      editInitApi(this.id)
        .then(r => {

          this.formdata = r;


          this.$refs.ClassUnitSelect.updateVal(r.unitid);
          this.$refs.ZhichenSelect.updateVal(r.zhicheng);
          this.$refs.PartyOrgSelect.updateVal(r.partyid);
        })
        .finally(() => {
          this.loading = false;
        });

      editInitGenderApi(this.id)
        .then(r => {
          this.formdata2 = r;
        })
    },

    onZhichenChanged(zcid){
      this.formdata.zhicheng = zcid;
    },

    OnUnitSelectValueChanged(unitid) {
      // console.log("OnUnitSelectValueChanged",unitid)
      this.formdata.unitid = unitid;
    },
    
    OnPartySelectValueChanged(partyid) {
      // console.log("OnPartySelectValueChanged",partyid)
      this.formdata.partyid = partyid;
    }


  },

  computed:{
    isAdmin(){
      return this.$store.getters["profileModule/isadmin"];
    },
    showZaibianEdit(){
      let jobary = ["预备党员","发展对象","积极分子"]
      if(this.formdata){
        if(this.formdata.isccp){
          return true;
        }
        else if (jobary.indexOf(this.formdata.partyjob) >= 0){
          return true;
        }
        else {
          return false;
        }
      }
      else {
        return false;
      }

    }
  },

  mounted(){
    this.id = this.$route.query.id;
    this.init();

    // console.log("admin",this.$store.getters["profileModule/isadmin"])
  }


}



</script>

<style scoped lang="scss">

._tips{
  width: 400px;
  font-size: 14px;
  color: #7c5111;
  display: inline-block;
  margin: 0px;
}


</style>

